import React, { useEffect } from "react";

import { TopNavigationContainer } from "./TopNavigation.styles";

interface TopNavigationProps {
  height: number;
  id?: string;
  children: React.ReactNode;
}

/**
 * Top navigation component that is always fixed at the top of the page.
 * Sets the --topNavigationHeight CSS custom property for use by other components.
 */
const TopNavigation: React.FC<TopNavigationProps> = ({ height, id, children }) => {
  useEffect(() => {
    // Set CSS custom property for top navigation height
    document.documentElement.style.setProperty("--topNavigationHeight", `${height}px`);

    return () => {
      document.documentElement.style.removeProperty("--topNavigationHeight");
    };
  }, [height]);

  return (
    <TopNavigationContainer id={id} $height={height}>
      {children}
    </TopNavigationContainer>
  );
};

export default TopNavigation;
